import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Enphase_IQ7+.png';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Enphase Micro Inverter" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Inverters/Enphase_IQ7.js